import { useMutationState } from '@tanstack/react-query';
import { useTRPC } from '../utils/trpc.js';

/**
 * Every environment with an `environments.pullNow` request in flight right now, read straight off
 * TanStack's mutation cache rather than hand-rolled local state — so `usePull`'s single pull and
 * its sequential `pullAll` agree on what's running, however either one was started. `pullNow`'s
 * mutation key comes from `mutationOptions()`, so every caller of it
 * lands in the same bucket here.
 */
export const usePullingEnvironments = (): Set<string> => {
    const trpc = useTRPC();
    const environments = useMutationState({
        filters: { mutationKey: trpc.environments.pullNow.mutationKey(), status: 'pending' },
        select: (mutation) => (mutation.state.variables as { environment: string }).environment,
    });
    return new Set(environments);
};
